import type { ReactNode } from "react";

const URL_REGEX = /https?:\/\/[^\s<>"']+/g;

function cleanUrl(url: string): string {
  return url.replace(/[.,;:!?)]+$/, "");
}

export function renderTextWithLinks(text: string, linkClassName?: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = URL_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
    const url = cleanUrl(match[0]);
    nodes.push(
      <a
        key={key++}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName ?? "text-purple-600 dark:text-purple-400 underline hover:text-purple-700 dark:hover:text-purple-300 break-all"}
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes.length ? nodes : [text];
}

export function AnnouncementBody({ body, className, paragraphClassName }: { body: string; className?: string; paragraphClassName?: string }) {
  return (
    <div className={className}>
      {body.split("\n\n").map((paragraph, i) => (
        <p key={i} className={paragraphClassName ?? "whitespace-pre-wrap"}>
          {renderTextWithLinks(paragraph)}
        </p>
      ))}
    </div>
  );
}
